// DS: C86
/** An animation put in place while we load the actual content */ import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Loader from '../Loader';
import OutlinedDASymbol from '../OutlinedDASymbol';
import { usePortalNode } from '../popper/hooks/usePortalNode';
import { useLoaderDelay } from './useLoaderDelay';
import s from './LoadingIndicator.scss';
const LoadingIndicatorPortal = ({ children })=>{
    const portalContainer = usePortalNode('loadingIndicator');
    return portalContainer && /*#__PURE__*/ ReactDOM.createPortal(children, portalContainer);
};
const LoadingIndicator = ({ view = 'spinner', coverMode = false, withOverlay = false, className, spinnerClassName, usePortal = false })=>{
    // Delayed showing for better UX
    const showLoader = useLoaderDelay();
    const content = /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], showLoader && s['visible'], s[`view-${view}`], coverMode && s['cover-mode'], withOverlay && s['with-overlay'], usePortal && s['fixed-position'], className)
    }, {
        daSymbol: /*#__PURE__*/ React.createElement(OutlinedDASymbol, null),
        daSymbolPurple: /*#__PURE__*/ React.createElement(OutlinedDASymbol, {
            palette: "purple"
        }),
        watchSuggestions: /*#__PURE__*/ React.createElement(OutlinedDASymbol, {
            palette: "green-to-purple"
        }),
        llama: /*#__PURE__*/ React.createElement(Loader, {
            size: "big"
        }),
        spinner: /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['spinner'], spinnerClassName)
        })
    }[view]);
    if (usePortal) {
        return /*#__PURE__*/ React.createElement(LoadingIndicatorPortal, null, content);
    }
    return content;
};
LoadingIndicator.displayName = 'LoadingIndicator';
export default LoadingIndicator;
